// extracted by mini-css-extract-plugin
export default {"heading":"written_heading__8+2g1","heading_failed":"written_heading_failed__3-D2G"};